import { Card } from 'react-bootstrap'
import "./All_providers_cards.css"

function All_providers_cards({ logo, altName,  providerName }) {
    return (
        <>
            <section className='All_providers_cards'>
                <div className='provider-card'>
                    <Card>
                        <Card.Body>
                            <div className='provider-items'>
                                <div className='logos'>
                                    <img src={logo} alt={altName} className='provider-logo' />
                                </div>
                                <div className='name'>
                                    <p className='provider-name'>{providerName}</p>
                                </div>
                            </div>
                        </Card.Body>
                    </Card>
                </div>
            </section>
        </>
    )
}

export default All_providers_cards